import React from 'react';

function Empty() {
  return (
    <div className='flex h-[80vh]'>
      <div className='m-auto'>
        <h3>No content available!</h3>
      </div>
    </div>
  );
}

export default Empty;
